/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyWebhookEventType,
  ListWebhookDeliveriesResponse,
  ListWebhooksResponse,
  RetryWebhookDeliveryRequest,
  SortDirection,
  WebhookDelivery,
  WebhookDeliveryDetail,
  WebhookDeliverySortKey,
  WebhookDeliveryState,
} from '../models/index';
import {
    CompanyWebhookEventTypeFromJSON,
    CompanyWebhookEventTypeToJSON,
    ListWebhookDeliveriesResponseFromJSON,
    ListWebhookDeliveriesResponseToJSON,
    ListWebhooksResponseFromJSON,
    ListWebhooksResponseToJSON,
    RetryWebhookDeliveryRequestFromJSON,
    RetryWebhookDeliveryRequestToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
    WebhookDeliveryFromJSON,
    WebhookDeliveryToJSON,
    WebhookDeliveryDetailFromJSON,
    WebhookDeliveryDetailToJSON,
    WebhookDeliverySortKeyFromJSON,
    WebhookDeliverySortKeyToJSON,
    WebhookDeliveryStateFromJSON,
    WebhookDeliveryStateToJSON,
} from '../models/index';

export interface GetWebhookDeliveryRequest {
    deliveryId: string;
}

export interface ListWebhookDeliveriesRequest {
    webhookId?: string;
    eventType?: CompanyWebhookEventType;
    state?: WebhookDeliveryState;
    createdFrom?: Date;
    createdTo?: Date;
    sortBy?: WebhookDeliverySortKey;
    sortDirection?: SortDirection;
    page?: number;
    pageSize?: number;
}

export interface RetryWebhookDeliveryOperationRequest {
    retryWebhookDeliveryRequest?: RetryWebhookDeliveryRequest;
}

/**
 * 
 */
export class WebhooksApi extends runtime.BaseAPI {

    /**
     * The exact request we sent, the response we received, and every delivery of the same event to the same endpoint.
     * One delivery with its bodies and attempt history
     */
    async getWebhookDeliveryRaw(requestParameters: GetWebhookDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebhookDeliveryDetail>> {
        if (requestParameters['deliveryId'] == null) {
            throw new runtime.RequiredError(
                'deliveryId',
                'Required parameter "deliveryId" was null or undefined when calling getWebhookDelivery().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['deliveryId'] != null) {
            queryParameters['deliveryId'] = requestParameters['deliveryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhooks/deliveries/get`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebhookDeliveryDetailFromJSON(jsonValue));
    }

    /**
     * The exact request we sent, the response we received, and every delivery of the same event to the same endpoint.
     * One delivery with its bodies and attempt history
     */
    async getWebhookDelivery(requestParameters: GetWebhookDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebhookDeliveryDetail> {
        const response = await this.getWebhookDeliveryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The webhooks configured on the caller\'s company, read-only. The Dashboard shows the Developers menu only to a company that has one, and offers them as a delivery filter.
     * The company\'s webhooks
     */
    async listCompanyWebhooksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWebhooksResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhooks/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWebhooksResponseFromJSON(jsonValue));
    }

    /**
     * The webhooks configured on the caller\'s company, read-only. The Dashboard shows the Developers menu only to a company that has one, and offers them as a delivery filter.
     * The company\'s webhooks
     */
    async listCompanyWebhooks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWebhooksResponse> {
        const response = await this.listCompanyWebhooksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Deliveries to the caller\'s company\'s webhooks within the retention window, filtered, sorted and paged on the server so a company with thousands of deliveries can still find one. Bodies are left out; use /webhooks/deliveries/get for one delivery\'s request and response.
     * One page of the company\'s webhook deliveries
     */
    async listWebhookDeliveriesRaw(requestParameters: ListWebhookDeliveriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWebhookDeliveriesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['webhookId'] != null) {
            queryParameters['webhookId'] = requestParameters['webhookId'];
        }

        if (requestParameters['eventType'] != null) {
            queryParameters['eventType'] = requestParameters['eventType'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['createdFrom'] = (requestParameters['createdFrom'] as any).toISOString();
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['createdTo'] = (requestParameters['createdTo'] as any).toISOString();
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhooks/deliveries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWebhookDeliveriesResponseFromJSON(jsonValue));
    }

    /**
     * Deliveries to the caller\'s company\'s webhooks within the retention window, filtered, sorted and paged on the server so a company with thousands of deliveries can still find one. Bodies are left out; use /webhooks/deliveries/get for one delivery\'s request and response.
     * One page of the company\'s webhook deliveries
     */
    async listWebhookDeliveries(requestParameters: ListWebhookDeliveriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWebhookDeliveriesResponse> {
        const response = await this.listWebhookDeliveriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends a failed delivery\'s original body again under a fresh signature and records the outcome as a new delivery pointing at the original.
     * Re-send a failed delivery
     */
    async retryWebhookDeliveryRaw(requestParameters: RetryWebhookDeliveryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebhookDelivery>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhooks/deliveries/retry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetryWebhookDeliveryRequestToJSON(requestParameters['retryWebhookDeliveryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebhookDeliveryFromJSON(jsonValue));
    }

    /**
     * Sends a failed delivery\'s original body again under a fresh signature and records the outcome as a new delivery pointing at the original.
     * Re-send a failed delivery
     */
    async retryWebhookDelivery(requestParameters: RetryWebhookDeliveryOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebhookDelivery> {
        const response = await this.retryWebhookDeliveryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
